/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
"use strict";

Shopify.theme.jsTopBar = {
  init: function init($section) {
      Shopify.theme.jsTopBar = $.extend(this, Shopify.theme.getSectionData($section));
    this.createSlider($section);
  },
  createSlider: function createSlider($section) {

	let _self = this
    this.slideshowEl = $section.find('[data-slider]')[0];

    this.slideshowEl.classList.remove('hidden')
    this.slider = new Flickity(this.slideshowEl, {
      autoPlay: this.speed == 0 ?false:this.speed * 1000,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: this.attraction / 100,
      friction: 0.8
    });

  },
  blockSelect: function blockSelect($section, blockId) {
    this.pause()
    var slider = $section.find('[data-slider]');
    var slideIndex = $('#shopify-section-' + blockId).data('index');
    this.slider.selectCell( slideIndex, true, true);
  },
  blockdeSelect:function blockdeSelect($section, blockId) {
    this.play()
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
     this.slider.flickity('destroy');
  }
};


/******/ })()
;